<template>
  <EntityOverview
    :name="'Nachrichten'"
    :entityType="'news'"
    :configAction="'getNewsConfig'"
    :latestDataEndpoint="env.news_api_client_url + 'news'"
    :matomoEndpoint="'https://matomo.api.eo-heimat.de'"
    :matomoSiteId="isDevEnvironment ? 5 : 6"
    :matomoTokenAuth="'72d0c8747156029f020882bb77535ca1'"
  />
</template>

<script setup>
import EntityOverview from "@/components/Statistics/Overview/EntityOverview.vue";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
const isDevEnvironment = ["env.dev", "env.local"].some(env =>
  process.env.VUE_APP_ENV_PATH.includes(env)
);
</script>
